import * as types from "./actionTypes";

export const postRegattaForms = (formName, formContent) => ({
  type: types.POST_REGATTA_FORMS,
  payload: { formName, formContent },
});

export const submitRegattaForms = (formName, formContent, typeCode) => ({
  type: types.SUBMIT_REGATTA_FORMS,
  payload: { formName, formContent, typeCode },
});

export const markDocumentReadRegatta = (documentFilename) => ({
  type: types.MARK_DOCUMENT_READ_REGATTA,
  payload: documentFilename,
});

export const setRegattaReadingLoading = (isLoading) => {
  return {
    type: types.SET_REGATTA_READING_LOADING,
    payload: isLoading,
  };
};

export const setRegattaAssessmentLoading = (isLoading) => {
  return {
    type: types.REGATTA_ASSESSMENT_IS_LOADING,
    payload: isLoading,
  };
};

export const regattaAssessmentSubmitted = (results) => ({
  type: types.REGATTA_ASSESSMENT_SUBMITTED,
  payload: results,
});

export const submitRegattaAssessment = (formName, formContent) => ({
  type: types.SUBMIT_REGATTA_ASSESSMENT,
  payload: { formName, formContent },
});
